/**
 * TikTok Pixel IDs are alphanumeric codes from Events Manager (e.g. CXXXXXXXXXXXXXXX).
 * Rejects emails, URLs, and other autofill noise.
 */
export function isValidTikTokPixelId(value) {
  if (!value || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (trimmed.length < 6 || trimmed.length > 30) return false;
  if (trimmed.includes("@") || trimmed.includes(" ") || trimmed.includes("://")) return false;
  return /^[A-Za-z0-9]+$/.test(trimmed);
}

/** Connected = valid pixel ID saved on company + Events API token on user. */
export function isTikTokPixelConnected(pixelId, accessToken) {
  return (
    isValidTikTokPixelId(pixelId) &&
    typeof accessToken === "string" &&
    accessToken.trim().length > 20
  );
}
